import React, { useState } from 'react';
import { Input, Select, DatePicker } from 'antd';
import { EyeOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import Button from '../button';
import { ClickOut } from '..';
import Wrapper, { FilterWrapper, SubButton } from './style';

const { Option } = Select;
const { RangePicker } = DatePicker;

const FilterComponent = (props) => {
  const {
    className,
    searchPlaceholder = 'Search...',
    onSearch,
    filterOptions = [],
    secondFilterOptions = [],
    onChangeFilter,
    filterPlaceholder = 'Filter',
    onChangeSecondFilter,
    secondFilterPlaceholder = 'Sort',
    onClickButton,
    showBtn,
    showSecondFilter,
    showFilter,
    showRangePicker,
    onChangeRangePicker,
    onOkRangePicker,
    btnText = 'Create',
    btnIcon = <PlusOutlined />,
    showSubBtn,
    listOfSubBtn = [],
    withBorder,
    isLoadingFilter,
    btnType = 'primary',
    showSecondBtn,
    secondBtnText = 'Preview',
    secondBtnType = 'secondary',
    secondBtnIcon = <EyeOutlined />,
    onClickSecondBtn,
    showButtonBesideSearch,
    btnBesideSearchText,
    btnBesideSearchType = 'secondary',
    btnBesideSearchIcon = <ReloadOutlined />,
    onClickButtonBesideSearch,
    btnBesideSearchClassName = '',
    additionalComponent,
    secondFilterSearch,
    isLoadingSecondFilter,
    filterSearch,
    onChangeSearchFilter,
    onChangeSecondSearchFilter,
    isLoadingButton = false,
    secondFilterProps,
    fullWidthSearch,
  } = props;

  const [isShowSubBtn, setIsShowSubBtn] = useState(false);

  const searchWidth = () => {
    if (showSecondFilter && !showFilter) {
      return {
        width: '512px',
      };
    }
    if (!showSecondFilter && showFilter) {
      return {
        width: '512px',
      };
    }

    if (showButtonBesideSearch) {
      return {
        maxWidth: '400px',
      };
    }

    if (fullWidthSearch) {
      return {
        width: '100%',
      };
    }

    return {
      width: '400px',
    };
  };

  const onClickBtn = () => {
    if (showSubBtn) {
      setIsShowSubBtn(true);
    }
    if (!showSubBtn) {
      onClickButton();
    }
  };

  const onClickOutside = () => {
    setIsShowSubBtn(false);
  };

  const isShowFilter = () => {
    return showFilter || showSecondFilter || showRangePicker;
  };

  return (
    <Wrapper className={className ?? ''}>
      <FilterWrapper
        withBorder={withBorder}
        fullWidthSearch={fullWidthSearch}
        isShowFilter={isShowFilter()}
      >
        <Input
          placeholder={searchPlaceholder}
          onChange={onSearch}
          style={searchWidth()}
        />
        {showButtonBesideSearch && (
          <Button
            icon={btnBesideSearchIcon}
            type={btnBesideSearchType}
            onClick={onClickButtonBesideSearch}
            className={btnBesideSearchClassName}
            loading={isLoadingButton}
          >
            {btnBesideSearchText}
          </Button>
        )}
        {isShowFilter() && (
          <div className="component_filter_component_select_wrapper">
            {showFilter && (
              <Select
                placeholder={filterPlaceholder}
                onChange={onChangeFilter}
                allowClear
                loading={isLoadingFilter}
                showSearch={filterSearch}
                onSearch={(input) => {
                  if (onChangeSearchFilter) {
                    onChangeSearchFilter(input);
                  }
                }}
                onBlur={() => {
                  if (onChangeSearchFilter) {
                    onChangeSearchFilter('');
                  }
                }}
              >
                {filterOptions.length > 0 &&
                  filterOptions.map((item) => {
                    return (
                      <Option value={item.value} key={item.id}>
                        {item.label}
                      </Option>
                    );
                  })}
              </Select>
            )}
            {showSecondFilter && (
              <Select
                placeholder={secondFilterPlaceholder}
                onChange={onChangeSecondFilter}
                allowClear
                showSearch={secondFilterSearch}
                loading={isLoadingSecondFilter}
                onSearch={(input) => {
                  if (onChangeSecondSearchFilter) {
                    onChangeSecondSearchFilter(input);
                  }
                }}
                onBlur={() => {
                  if (onChangeSecondSearchFilter) {
                    onChangeSecondSearchFilter('');
                  }
                }}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...secondFilterProps}
              >
                {secondFilterOptions.length > 0 &&
                  secondFilterOptions.map((item) => {
                    return (
                      <Option value={item.value} key={item.id}>
                        {item.label}
                      </Option>
                    );
                  })}
              </Select>
            )}
            {showRangePicker && (
              <RangePicker
                format="YYYY-MM-DD"
                onChange={onChangeRangePicker}
                onOk={onOkRangePicker}
              />
            )}
          </div>
        )}
        {additionalComponent && (
          <div className="component_filter_component_additional_component">
            {additionalComponent()}
          </div>
        )}
      </FilterWrapper>
      {showBtn && (
        <div className="component_search_component_btn_wrapper">
          {showSecondBtn && (
            <Button
              onClick={onClickSecondBtn}
              type={secondBtnType}
              icon={secondBtnIcon}
              htmlType="button"
              loading={isLoadingButton}
            >
              {secondBtnText}
            </Button>
          )}
          <Button
            onClick={onClickBtn}
            type={btnType}
            icon={btnIcon}
            htmlType="button"
            loading={isLoadingButton}
          >
            {btnText}
          </Button>
          {showSubBtn && isShowSubBtn && (
            <ClickOut onClickOutside={onClickOutside}>
              <div className="component_search_component_sub_btn_wrapper">
                {listOfSubBtn.map((item) => {
                  return (
                    <SubButton
                      className="font-paragraph"
                      key={item.id}
                      aria-hidden="true"
                      onClick={() => {
                        if (item.onClick) {
                          item.onClick();
                        }
                        setIsShowSubBtn(false);
                      }}
                    >
                      {item.icon}
                      {item.text}
                    </SubButton>
                  );
                })}
              </div>
            </ClickOut>
          )}
        </div>
      )}
    </Wrapper>
  );
};

export default FilterComponent;
